import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Tab,
  Tabs,
} from '@material-ui/core';
import Page from '../../components/Page';
import PaymentAgreementInfo from './PaymentAgreementShow/Index';
import {useParams} from 'react-router-dom';
import Loading from '../../components/Loading/Loading';
import { api_get } from "../../utils/Api";
import SimpleToolbar from '../../components/Toolbar/SimpleToolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

const UserShow = (props) => {
  const {Link , pageLink, title, ...rest} = props;
  const {id} = useParams();
  const classes = useStyles();
  const [paymentAgreement, setPaymentAgreement] = useState([]);
  const [currentTab, setCurrentTab] = useState('details');

  const tabs = [
    {value: 'details', label: 'Payment agreement details'},
  ];

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  useEffect(() => {
    api_get(`payment-agreements/${id}`).then((result) => {
      setPaymentAgreement(result.payload);
    });
  }, []);
  if (!Object.keys(paymentAgreement).length) {
    return (<Loading/>);
  }
  return (
    <div>
      <SimpleToolbar
         Link = {Link}
         pageLink = {'/finance/payment-agreements'}
         title = {'Payment Agreements'} />
      <Page
        className={classes.root}
        title="Payment agreement Details"
      >
        <Container maxWidth={false}>
          <Box mt={3}>
            <Tabs
              onChange={handleTabsChange}
              scrollButtons="auto"
              value={currentTab}
              variant="scrollable"
              textColor="secondary"
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                />
              ))}
            </Tabs>
          </Box>
          <Divider/>
          <Box mt={3}>
            {currentTab === 'details' && <PaymentAgreementInfo paymentAgreement={paymentAgreement} slices={paymentAgreement.payment_agreement_slices}/>}
          </Box>
        </Container>
      </Page>
    </div>

  );
};

UserShow.propTypes = {
    Link: PropTypes.elementType.isRequired,
    pageLink: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };
export default UserShow;
